module.exports = __webpack_public_path__ + "static/img/u40.1727fe63.png";